import React from 'react';
import './styles/Login.css';
import {CustomButton} from "../Shared/components/CustomButton.jsx";
import {useNavigate} from "react-router-dom";
import { useHasLoggedInBefore } from '../Shared/hooks/useHasLoggedInBefore.js';
export default function Login(menuVisible) {

    const navigate = useNavigate();
    const userLoggedIn = useHasLoggedInBefore();

    return (
        <div className={`header__login-signup-container ${menuVisible ? 'visible' : ''}`}>
            {
                userLoggedIn
                    ? <CustomButton
                        className="header-auth__button"
                        text="Log In"
                        styleType={userLoggedIn ? "tertiary" : "primary"}
                        onClick={() => { window.location.assign('/login'); }}
                    />
                    : <CustomButton
                        className="header-auth__button"
                        text="Sign Up"
                        styleType="tertiary"
                        onClick={() => navigate("/signup")}
                    />
            }
        </div>
    );
}